import React from 'react';
import PropTypes from 'prop-types';
import Message from 'components/Message';
import MessageContent from 'components/messages/MessageContent';

const PasswordResetSuccesMessage = ({ onDismiss }) => (
  <Message
    type="info"
    onDismiss={onDismiss}
    message={(
      <MessageContent>
        Thank you, you have successfully changed your password.
        Make sure you use the new password next time you log in.
      </MessageContent>
    )}
  />
);

PasswordResetSuccesMessage.displayName = 'PasswordResetSuccesMessage';

PasswordResetSuccesMessage.propTypes = {
  onDismiss: PropTypes.func,
};

PasswordResetSuccesMessage.defaultProps = {
  onDismiss: null,
};

export default PasswordResetSuccesMessage;
